/**
 * Sekeleton loader for products
 */

export class SkeletonLoader {
	constructor(skeletonSelector, itemSelector) {
		this.itemSelector = itemSelector;
		this.skeletonSelector = skeletonSelector;

		this.skeletonItems = document.querySelectorAll(this.skeletonSelector);
		this.loadedItems = document.querySelectorAll(this.itemSelector);
	}

	show() {
		this.skeletonItems.forEach((item) => {
			item.classList.remove('hidden');
		});

		this.loadedItems.forEach((item) => {
			item.classList.add('hidden');
		});
	}

	hide() {
		this.skeletonItems.forEach((item) => {
			item.classList.add('hidden');
		});

		// Get new loaded items
		this.loadedItems = document.querySelectorAll(this.itemSelector);

		this.loadedItems.forEach((item) => {
			item.classList.remove('hidden');
		});
	}
}
